<template>
  <v-modal
    :backdrop-static="true"
    @closed="emitAuthorizationModalClosedEvent">
    <template #modal-header>
      <span class="h6">Authorize payment</span>
    </template>

    <template #default>
      <div class="stripe-3ds-validation">
        <div v-if="['loading','validation-accepted','validation-cancelled'].includes(status)"
             class="stripe-loader d-flex align-items-center justify-content-center">
          <div class="loader-inner">
            <div class="load loader-1"></div>
            <div class="load loader-2"></div>
            <div class="load loader-3"></div>
            <div class="load loader-4"></div>
            <div class="load loader-5"></div>
            <div class="load loader-6"></div>
            <div class="load loader-7"></div>
            <div class="load loader-8"></div>
          </div>
        </div>

        <iframe
          v-if="['loading','waiting-for-validation'].includes(status)"
          :height="status === 'loading' ? 'auto' : '800'"
          :src="url"
          width="100%">
        </iframe>
      </div>
    </template>
  </v-modal>
</template>

<script>
import VModal from './vendor/modal/VModal';

export default {
  name: 'TheCheckoutPaymentAuthorizationModal',
  components: {
    VModal,
  },
  data() {
    return {
      status: 'loading',
    };
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  emits: ['validation-accepted', 'validation-cancelled'],
  methods: {
    emitAuthorizationModalClosedEvent() {
      this.$emit('authorization-modal-closed');
    },
    doHandleAuthorization(ev) {
      if (ev.data?.type === 'loaded') {
        // Iframe is loaded
        this.status = 'waiting-for-validation';
      } else if (ev.data.type === 'stripe-3ds-result') {
        if (ev.data.message.error) {
          this.status = 'validation-cancelled';
          this.$emit('validation-cancelled');
        } else {
          this.status = 'validation-accepted';
          this.$emit('validation-accepted');
        }
      }
    },
  },
  created() {
    window.addEventListener('message', this.doHandleAuthorization, null);
  },
  unmounted() {
    window.removeEventListener('message', this.doHandleAuthorization, null);
  },
};
</script>

<style lang="scss" scoped>
.stripe-3ds-validation {
  min-height: 50rem;
}

.stripe-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .loader-inner {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;

    .load {
      animation: roller-loader 2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      transform-origin: 40px 40px;

      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #fff;
        margin: -4px 0 0 -4px;
      }
    }

    .loader-1 {
      animation-delay: -0.036s;

      &:after {
        top: 63px;
        left: 63px;
      }
    }

    .loader-2 {
      animation-delay: -0.072s;

      &:after {
        top: 68px;
        left: 56px;
      }
    }

    .loader-3 {
      animation-delay: -0.108s;

      &:after {
        top: 71px;
        left: 48px;
      }
    }

    .loader-4 {
      animation-delay: -0.144s;

      &:after {
        top: 72px;
        left: 40px;
      }
    }

    .loader-5 {
      animation-delay: -0.18s;

      &:after {
        top: 71px;
        left: 32px;
      }
    }

    .loader-6 {
      animation-delay: -0.216s;

      &:after {
        top: 68px;
        left: 24px;
      }
    }

    .loader-7 {
      animation-delay: -0.252s;

      &:after {
        top: 63px;
        left: 17px;
      }
    }

    .loader-8 {
      animation-delay: -0.288s;

      &:after {
        top: 56px;
        left: 12px;
      }
    }

    @keyframes roller-loader {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
